module.exports = __webpack_public_path__ + "assets/img/myWallet-back.8594293b.png";